<template>
    <div>
        <div ref="distributionProjectionChart" style="height: 500px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart: null,
            }
        },
        mounted () {
            this.createChart();
        },
        methods : {
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                let chart = am4core.create(this.$refs.distributionProjectionChart, am4charts.XYChart);

                chart.dateFormatter.dateFormat = "MMM YYYY";
                chart.numberFormatter.numberFormat = "#.#a";
                chart.numberFormatter.bigNumberPrefixes = [
                { "number": 1e+3, "suffix": "K" },
                { "number": 1e+6, "suffix": "M" },
                { "number": 1e+9, "suffix": "B" }
                ];

                // Add data
                chart.data = [{
                "date": new Date(2020, 0, 1),
                    "pengeluaran": 0,
                    "pemesanan": 10,
                }, {
                "date": new Date(2020, 1, 1),
                    "pengeluaran": 4000,
                    "pemesanan": 5000,
                }, {
                "date": new Date(2020, 2, 1),
                    "pengeluaran": 55000,
                    "pemesanan": 65000,
                }, {
                "date": new Date(2020, 3, 1),
                    "pengeluaran": 420000,
                    "pemesanan": 320000,
                }, {
                "date": new Date(2020, 4, 1),
                    "pengeluaran": 390000,
                    "pemesanan": 490000,
                }, {
                "date": new Date(2020, 5, 1),
                    "pengeluaran": 850000,
                    "pemesanan": 650000,
                }, {
                "date": new Date(2020, 6, 1),
                    "pengeluaran": 650000,
                    "pemesanan": 720000,
                    "projection": 720000,
                }, {
                "date": new Date(2020, 7, 1),
                    "projection": 900000,
                }, {
                "date": new Date(2020, 8, 1),
                    "projection": 1153000
                }, {
                "date": new Date(2020, 9, 1),
                    "projection": 1349000
                }, {
                "date": new Date(2020, 10, 1),
                    "projection": 1504000
                }, {
                "date": new Date(2020, 11, 1),
                    "projection": 1742000
                }];

                // Create axes
                let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.grid.template.location = 0;
                dateAxis.renderer.minGridDistance = 30;

                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.inside = true;
                valueAxis.renderer.labels.template.verticalCenter = "bottom";
                valueAxis.renderer.labels.template.dx = -5;
                valueAxis.renderer.labels.template.dy = 10;
                valueAxis.renderer.maxLabelPosition = 0.95;
                // valueAxis.title.text = "Number of infections";
                // valueAxis.title.marginRight = 5;

                // Create series
                function createSeries(field, name, color, dashed) {
                let series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.dateX = "date";
                series.name = name;
                series.tooltipText = "[bold]{name}[/]\n{dateX}: [b]{valueY}[/]";
                series.strokeWidth = 2;
                series.smoothing = "monotoneX";
                series.stroke = color;
                
                if (dashed) {
                    series.strokeDasharray = "5 3";
                }
                
                return series;
                }

                createSeries("pemesanan", "Pemesanan QR", am4core.color("#A94AE4"));
                createSeries("pengeluaran", "Pengeluaran QR", am4core.color("#2FBF56"));
                createSeries("projection", "Prediksi Pemesanan", am4core.color("#A94AE4"), true);


                chart.legend = new am4charts.Legend();
                chart.cursor = new am4charts.XYCursor();
            }
        }
    }
</script>